import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
export default Vue.extend({
    props: ["target"],
    methods: {
        ...mapActions("variableSalaryModal", ["setHoveredVariable"]),
    },
    computed: {
        ...mapGetters("variableSalaryModal", ["hoveredVariable"]),
        color() {
            if (this.target === this.hoveredVariable) {
                return "primary";
            }
        },
    },
});
